import React, { memo } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  Position,
  getBezierPath,
} from 'reactflow';
import EdgeDeleteButton from './EdgeDeleteButton';

interface SelectableDefaultEdgeProps {
  id: string;
  sourceX: number;
  sourceY: number;
  sourcePosition?: Position;
  targetX: number;
  targetY: number;
  targetPosition?: Position;
  selected?: boolean;
  style?: React.CSSProperties;
  markerEnd?: string;
  markerStart?: string;
}

function SelectableDefaultEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
  style,
  markerEnd,
  markerStart,
}: SelectableDefaultEdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const normalStrokeWidth = Number(style?.strokeWidth || 1);
  const fixedMarkerId = `fixed-marker-${id}`;
  const fixedMarkerSize = 25 * normalStrokeWidth;

  return (
    <>
      {selected && markerEnd && (
        <defs>
          <marker
            id={fixedMarkerId}
            markerWidth={fixedMarkerSize}
            markerHeight={fixedMarkerSize}
            viewBox='-10 -10 20 20'
            markerUnits='userSpaceOnUse'
            orient='auto-start-reverse'
            refX='0'
            refY='0'
          >
            <polyline
              stroke='red'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1'
              fill='red'
              points='-5,-4 0,0 -5,4 -5,-4'
            />
          </marker>
        </defs>
      )}
      <BaseEdge
        path={edgePath}
        interactionWidth={20}
        markerEnd={selected && markerEnd ? `url(#${fixedMarkerId})` : markerEnd}
        markerStart={markerStart}
        style={{
          ...style,
          stroke: selected ? '#3650DE' : (style?.stroke || '#6e75ff'),
          strokeWidth: selected ? 3 : normalStrokeWidth,
        }}
      />
      {selected && (
        <EdgeLabelRenderer>
          <EdgeDeleteButton id={id} labelX={labelX} labelY={labelY} />
        </EdgeLabelRenderer>
      )}
    </>
  );
}

export default memo(SelectableDefaultEdge);
